import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {SessionService} from '@core/services/session.service';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate, CanActivateChild {

    constructor(private _router: Router,
                private _session: SessionService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Check if the user has access.
        const hasAccess = !!this._session.isAdmin || this._session.isAgent || this._session.isPlatformAdmin;

        // Check if the token does not exist.
        if (!hasAccess) {
            this._router.navigate(['/admin/auth']).then(_ => _);
        }

        return hasAccess;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(childRoute, state);
    }

}
